import React from 'react';
import { Col, Row } from 'reactstrap';

import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import SelectInputFieldControlled from 'components/layout/forms/SelectInputFieldControlled';
import TrashIcon from 'components/layout/buttons/TrashIcon';

const DoorSelectRow = ({
  doors,
  getAddDoorButton,
  onDeleteDoor,
  selectedDoor,
  setSelectedDoor,
}: {
  doors: IGlassWallDoor[];
  getAddDoorButton: (size?: string) => JSX.Element;
  onDeleteDoor: () => void;
  selectedDoor: number;
  setSelectedDoor: (selectedDoorId: number) => void;
}): JSX.Element => {
  const onChange = (event: any) =>
    setSelectedDoor(parseInt(event.target.value, 10));

  return (
    <Row>
      <Col xs={8}>
        <SelectInputFieldControlled
          id="door-select"
          onChange={onChange}
          required
          options={doors.map((door, index) => (
            <option key={door.id} value={index}>
              {door.areaName}
            </option>
          ))}
          value={selectedDoor}
        />
      </Col>
      <Col>
        {getAddDoorButton('xs')}
        <TrashIcon className="modal-delete-button" onClick={onDeleteDoor} />
      </Col>
    </Row>
  );
};

export default DoorSelectRow;
